import { useSelector } from 'react-redux'
import { blueGrey } from '@mui/material/colors'
import { Box } from '@mui/system'
import DOMPurify from 'dompurify'

import { selectOrganisation } from '@/app/slices/organisationSlice'

const classes = {
    content: {
        backgroundColor: 'background.paper',
        borderRadius: 2,
        border: `1px solid ${blueGrey[200]}`,
        width: '100%',
        padding: 3,
    },

    divider: {
        borderStyle: 'dashed',
        borderColor: blueGrey[200],
    },
}
const OrderCustomInstructions = () => {
    const storeSettings = useSelector(selectOrganisation)

    const customInstructions = DOMPurify.sanitize(storeSettings?.webStoreCustomOrderInstructions || '')

    return (
        <Box
            sx={[
                {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                },
                classes.content,
            ]}
        >
            <Box
                dangerouslySetInnerHTML={{ __html: customInstructions }}
                sx={{
                    '& p': {
                        margin: 0,
                    },
                }}
            />
        </Box>
    )
}

export default OrderCustomInstructions
